import { render, staticRenderFns } from "./ChooseBaseModal.vue?vue&type=template&id=01552718&scoped=true"
import script from "./ChooseBaseModal.vue?vue&type=script&lang=js"
export * from "./ChooseBaseModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseBaseModal.vue?vue&type=style&index=0&id=01552718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01552718",
  null
  
)

export default component.exports